<div class="container">
    <br>
    <br>
    <br>

    <br>
    <br>

    <br>
    <div class="row">
        <div class="col-12 col-md-12">
            <div class="row mb-4">
                <div class="col-md-12 ml-auto mr-auto text-center">
                    <h1 class="title mt-2">PROGRAMA DE APOYO A MAESTROS 2024</h1>
                    <h5>Consulta el estado de la solicitud</h5>
                </div>
            </div>

            <div class="card-body">

                <div class="row">
<!--
                    <div class="col-12  col-md-12" align="center">
                        <select style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" class="form-select"
                            aria-label="Selecciona Opcion de Busqueda" (change)="opcionSelect()" [(ngModel)]="tipo"
                            style="max-width: 500px;">
                          <option value="0" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">
                                Selecciona Opcion de Busqueda</option>
                            <option value="1" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Captura
                            tu CURP</option>
                           <option value="2" style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;">Por
                                Nombre Completo</option

                        </select>
                    </div>
    
                </div>
            -->             
                <!--
                <div class="row">
                    <div class="col-md-12 mt-5">
                        <small id="emailHelp" class="form-text text-muted"
                            style="font-weight: 300;text-transform: uppercase;">
                            <strong>Cualquier duda o aclaración marcar al departamento de becas: (867) 711 35 05 - Ext.
                                3409</strong></small>

                    </div>
                </div>
                -->
                <br>

<!--
                <div class="row" *ngIf="!porFolio  && tipo!='0'">
                    <div class="col-md-3 text-left"></div>
                    <div class="col-md-6 text-left">
                        <div class="col-12 col-md-12 text-left">
                            <div class="mb-3 text-left">
                                <label class="form-label" class="colorSecundario">Nombre(s)</label>
                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text"
                                    class="form-control" [(ngModel)]="nombre">
                                <small id="emailHelp" class="form-text text-muted" style="font-weight: 200;">Si tiene
                                    mas de un nombre, favor de especificarlo en la busqueda.</small>
                            </div>
                            <div class="mb-3">
                                <label class="form-label" class="colorSecundario">Apellido Paterno</label>
                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text"
                                    class="form-control" placeholder="" [(ngModel)]="apaterno">

                            </div>
                            <div class="mb-3">
                                <label class="form-label" class="colorSecundario">Apellido Materno</label>
                                <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;" type="text"
                                    class="form-control" placeholder="" [(ngModel)]="amaterno">

                            </div>
                        </div>

                    </div>
                    <div class="col-md-3 text-left"></div>
                    <div class="row">
                        <div class="col-md-12">
                            <small id="emailHelp" class="form-text text-muted"
                                style="font-weight: 300;text-transform: uppercase;">
                                <strong>**Si el nombre esta mal escrito no
                                    lo podremos encontrar en la base de datos y darle un resultado
                                    correcto.</strong></small>

                        </div>

                    </div>
                </div>
            -->

        
                <div class="row" *ngIf="tipo=='1'">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                        <h5 class="colorSecundario" style="margin-bottom:0;padding-bottom:0px">Escribe tu numero de Folio</h5>
                        <p style="font-size:14px;margin-top:0;padding-top:0px">Incluir solo los numeros.</p>
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="input-group input-group-alternative">
                                    <h1 style="font-size:xxx-large;padding-right: 5px;"> AM- </h1>
                                    <!-- <div class="input-group-prepend"><span class="input-group-text">
                                     
                                        <i
                                                class="bi bi-search"></i>
                                    
                                            </span></div>-->
                                    <input style="color:rgb(77, 65, 69);font-size:medium;font-weight: 400;"
                                         type="number" [(ngModel)]="folio" name="folio"
                                        (keydown)="onKeydownEvent()" aria-label="Escribe "
                                        class="form-control" placeholder="" type="text" required>
                                </div>
                            </div>
                            <!-- <div *ngIf="folio.errors?.pattern" class="alert alert-danger" role="alert">
                                                                Folio no valido, verifique que este tecleado correctamente. Recuerde que el folio inicia con la
                                                                letra B
                                                            </div>-->
                        </div>

                    </div>
                    <div class="col-md-3"></div>

                </div>

                <div class="row mt-5">
                    <div class="col-md-12" align="center">

                        <div class="form-group">
                            <!--   <ngx-recaptcha2 *ngIf="!norobot" ngModel name="captcha" [siteKey]="siteKey" (success)="handleSuccess($event)" [useGlobalDomain]="false"
                                        [hl]="lang" (expire)="handleExpire($event)">
                                    </ngx-recaptcha2>
                                -->
                            <button *ngIf="tipo!='0'" class="btn btn-primary pull-right" type="button"
                                (click)="enviarFolio()"> <span> <i class="bi bi-search"></i> Buscar</span>
                            </button>
                        </div>

                    </div>
                </div>
                <br>
                <br>
                <br>

                <div *ngIf="bandera" class="row align-items-center justify-content-center text-center"
                    style="background-color: #ffffff;">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" *ngIf="estado=='AUTORIZADO'">
                        <!--
                        <div style="font-size:1.5em;" class="form-group">
                            <h3 style="color: #BB955E;">Folio</h3>
                            <h5 class="font-weight-bold">{{folio2}}</h5>
                        </div>
                    -->
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-5">
                        <div style="font-size:1.5em;" class="form-group">
                            <h3 style="color: #BB955E">Estatus</h3>
                            <h4 class="font-weight-bold">
                                <span>
                                </span> {{this.estado}}
                            </h4>
                        </div>
                        <div class="col-md-12 mt-5">
                            
                            <h4>
                                {{escuela}}
                            </h4>
                        </div>
                    </div>
                    
                </div>
                <br>
                <br>
                <br>

            </div>

        </div>
    </div>
</div>

